export const STEP_KEYS = {
  RESET_PASSWORD: 'RESET_PASSWORD',
  SUBMIT: 'SUBMIT',
}

export const MODAL_STEPS = [
  {
    label: null,
    key: STEP_KEYS.RESET_PASSWORD,
  },
  {
    label: null,
    key: STEP_KEYS.SUBMIT,
  },
]
